export class EmailCallDto {
  name:string;
  phone:string;
}
